export class Modal {
    constructor() {
        this.element = document.querySelector('.modal');
        this.content = this.element.querySelector('.modal__content');
        this.closeButton = this.element.querySelector('.modal__close');
        this.pageWrapper = document.querySelector('.page__wrapper');
        // Привязываем контекст для обработчика ESC
        this.escHandler = this.handleEscape.bind(this);
        // Инициализируем обработчики
        this.setupEventListeners();
    }
    setupEventListeners() {
        // Закрытие по клику на оверлей
        this.element.addEventListener('click', (e) => {
            if (e.target === this.element) {
                this.close();
            }
        });
        // Закрытие по клику на крестик
        this.closeButton.addEventListener('click', () => {
            this.close();
        });
    }
    handleEscape(e) {
        if (e.key === 'Escape') {
            this.close();
        }
    }
    open(content) {
        // Блокируем прокрутку страницы
        this.pageWrapper.classList.add('page__wrapper_locked');
        document.body.style.paddingRight = this.getScrollbarWidth() + 'px';
        // Сохраняем текущий контент, если он есть
        const currentContent = this.content.firstElementChild;
        // Проверяем, нужно ли сохранять состояние текущей формы
        if (currentContent &&
            currentContent.classList.contains('form') &&
            content.classList.contains('form')) {
            // Не очищаем контент, просто заменяем его
            this.content.replaceChild(content, currentContent);
        }
        else {
            // В остальных случаях очищаем и добавляем новый контент
            this.content.innerHTML = '';
            this.content.appendChild(content);
        }
        this.element.classList.add('modal_active');
        document.addEventListener('keydown', this.escHandler);
    }
    close() {
        this.element.classList.remove('modal_active');
        this.content.innerHTML = '';
        document.removeEventListener('keydown', this.escHandler);
        // Разблокируем прокрутку страницы
        this.pageWrapper.classList.remove('page__wrapper_locked');
        document.body.style.paddingRight = '';
    }
    getContent() {
        return this.content;
    }
    getScrollbarWidth() {
        var _a;
        const outer = document.createElement('div');
        outer.style.visibility = 'hidden';
        outer.style.overflow = 'scroll';
        document.body.appendChild(outer);
        const inner = document.createElement('div');
        outer.appendChild(inner);
        const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;
        (_a = outer.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(outer);
        return scrollbarWidth;
    }
}
